import React from 'react';
import { Field } from 'redux-form';
import { FormGroupInput } from '../../../../common/form/components/components';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';
import './EmailOverrides.scss';

const EmailOverrides = ({}) => {

  return (
    <WhiteLabelContentContainer title={'Email Overrides'} >
      <Field
        name="meta.whitelabel.email_content_override.phone"
        component={FormGroupInput}
        label={'Phone'}
        labelSize={2}
        colSize={10}
      />
      <Field
        name="meta.whitelabel.email_content_override.name"
        component={FormGroupInput}
        label={'Broker Name'}
        labelSize={2}
        colSize={10}
      />
      <Field
        name="meta.whitelabel.email_content_override.email"
        component={FormGroupInput}
        label={'Broker Email'}
        labelSize={2}
        colSize={10}
      />
    </WhiteLabelContentContainer>
  );
};
export default EmailOverrides;
